// extracted by mini-css-extract-plugin
module.exports = {"item":"AccountTreatmentList_item__wosjd","image":"AccountTreatmentList_image__sn60J","limit":"AccountTreatmentList_limit__GmQQ4"};